import { login } from "@/api/user";
import { getToken, setToken, removeToken, getUserName, setUserName, removeUserName } from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
    token: getToken(),
    userName: getUserName()
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_USERNAME: (state, userName) => {
        state.userName = userName;
    }
};

const actions = {
    login ({ commit }, userInfo) {
        const comUscc = userInfo.comUscc;
        return new Promise((resolve, reject) => {
            login(comUscc)
                .then((response) => {
                    const { data } = response;
                    if (data) {
                        commit("SET_TOKEN", data.id);
                        commit("SET_USERNAME", data.userName);
                        setToken(data.id);
                        setUserName(data.userName);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    // 统一认证登录（个人）：使用 Authorization / jfUserInfo，不调后端 /user/loginAuth
    authLogin ({ commit }) {
        return new Promise((resolve, reject) => {
            try {
                const authorization = sessionStorage.getItem("Authorization");
                const jfUserInfoStr = sessionStorage.getItem("jfUserInfo");
                if (!authorization || !jfUserInfoStr) {
                    reject(new Error("未找到认证信息"));
                    return;
                }
                const jfUserInfo = JSON.parse(jfUserInfoStr);
                const userName = jfUserInfo.name || jfUserInfo.userName || jfUserInfo.uno || "";
                if (userName) {
                    commit("SET_USERNAME", userName);
                    setUserName(userName);
                }
                commit("SET_TOKEN", authorization);
                setToken(authorization);
                resolve({ id: jfUserInfo.uid || authorization, userName, ...jfUserInfo });
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },

    resetToken ({ commit }) {
        return new Promise((resolve) => {
            commit("SET_TOKEN", "");
            commit("SET_USERNAME", "");
            removeToken();
            removeUserName();
            sessionStorage.removeItem("jfUserInfo");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("Authorization");
            sessionStorage.removeItem("authInProgress");
            sessionStorage.removeItem("authCode");
            localStorage.clear();
            sessionStorage.clear();
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
